exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*  .braintree-method .braintree-method__label {\n      color: #ccc;\n  }\n\n  .braintree-heading {\n      display: none;\n  }\n\n  .braintree-method.braintree-method--active {\n      background: transparent;\n      border: none;\n      box-shadow: none;\n      padding: 0;\n  }\n\n  .braintree-toggle {\n      padding: 0;\n      background: transparent;\n      color: #fff;\n      text-align: left;\n  }\n\n  .braintree-toggle span {\n      border: none;\n  }*/\n", ""]);

// exports
